/*
 *
 * MUTATION FILE: ONLY FOR STATE MODIFICATION
 * - RULES:
 *   - MUST NOT HAVE ANY BUSINESS LOGIC
 *   - CANNOT CONTAIN ANY ASYNC OR PROMISE -> NO API CALLS
 *
 */

/*
 * ******************************************************************************
 * AUTORIZACIÓN                                                                 *
 ********************************************************************************/
/**
 * Incluye el jwt cuando el login se hace correctamente.
 * @param {any} state
 * @param {any} jwtPayLoad
 */
export const LoginSuccess = function (state, jwtPayLoad) {
  state.auth.jwtToken = jwtPayLoad;
};

/**
 * Mutación para cambiar el flag que determina si se ha terminado o no el flujo de autenticación.
 * @param {any} state
 * @param {any} flag
 */
export const AuthReady = function (state, flag) {
  state.auth.isAuthReady = flag;
};
export const BackLogin = function (state, flag) {
  state.auth.isBackLogin = flag;
};
export const LoginErrorFlag = function (state, flag) {
  state.auth.isLoginError = flag;
};

/**
 * Gestión del jwt cuando el login es erróneo.
 * @param {any} state
 */
export const LoginError = function (state) {
  state.auth.jwtToken = null;
  state.auth.isLoginError = true;
};
/**
 * Gestión del jwt cuando se hace logout.
 * @param {any} state
 */
export const Logout = function (state) {
  state.auth.jwtToken = null;
};

/**
 * Modifica el langCode
 * @param {any} state
 * @param {any} langCode
 */
export const LangCode = function (state, langCode) {
  state.langCode = langCode;
};

/**
 * Setea la instancia
 * @param {any} state
 * @param {any} instance
 */
export const Instance = function (state, instance) {
  state.auth.jwtToken.instance = instance;
};

/**
 * Añade un elemento dentro de la colección de paramLists.
 * @param {any} state
 * @param {any} nItem
 */
export const SetParamListItem = function (state, nItem) {
    /* Se itera por los paramListItem para ver si está en el el estado */
  for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
    /* Si el lenguaje y el codparam están */
    if (
      state.paramListItems[lCnt].codParam == nItem.codParam &&
      state.paramListItems[lCnt].langCode == nItem.langCode
    ) {
      /* Elemento encontrado en el estate ya descargado del servidor */
      return;
    }
  }
  /* El elemento no estaba y se añade */
  state.paramListItems.push(nItem);
};

/**
 * Añade un elemento paramId dentro de la colección de paramListCombos.
 * @param {any} state
 * @param {any} nItem
 */
export const SetParamListComboItem = function (state, nItem) {
  /* Se itera por los paramListItem para ver si está en el el estado */
  for (var lCnt = 0; lCnt < state.paramListCombos.length; lCnt++) {
    /* Si el lenguaje y el codparam están */
    if (
      state.paramListCombos[lCnt].paramId == nItem.paramId &&
      state.paramListCombos[lCnt].langCode == nItem.langCode
    ) {
      /* Elemento encontrado en el estate ya descargado del servidor */
      return;
    }
  }
  /* El elemento no estaba y se añade */
  state.paramListCombos.push(nItem);
};

/**
 * Abre o cierra el widget card buffer
 * @param {any} state
 * @param {any} isCollapsed
 */
export const setWidgetCardsBufferCollapsed = function (state, isCollapsed) {
    state.widgetCardsBuffer.isCollapsed = isCollapsed;
};

/**
 * agrega un item al widget card buffer
 * @param {any} state
 * @param {any} item
 */
export const pushWidgetCard = function (state, item) {
    state.widgetCardsBuffer.data.push(item);
};

/**
 * Elimina un item del widget card buffer por id
 * @param {any} state
 * @param {any} itemKey
 */
export const removeWidgetCard = function (state, itemKey) {
    const index = state.widgetCardsBuffer.data.map((x) => { return x.properties.keyId }).indexOf(itemKey)
    state.widgetCardsBuffer.data.splice(index, 1);
};

export const ComponentsActivation = function (state, components) {
  state.componentsActivation = components;
};
